export const gColr = {
  toolbar: "#b3deff",
  tb_height: 40,
  btgroup: "#F6F4EB",
};
